module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Library-c7e7b84692727dce5a9271d0f5368456.svg";